// TODO: Move this to @homein/utils
import { environment } from '../../environments/environment';
import { Paginable, PaginableParams } from './pagination.utils';

const ERROR_RATE_PERCENTAGE = 20;

export function paginateMockData<T>(data: T[], { limit, page }: PaginableParams): Paginable<T> {
  const totalSubsetItems = data.length;
  const calculatedTotalPages = Math.ceil(totalSubsetItems / limit);
  const totalPages = calculatedTotalPages > 0 ? calculatedTotalPages : 1;
  const maxVisiblePages = 5;
  let pages: number[];

  if (calculatedTotalPages <= maxVisiblePages) {
    pages = Array.from({ length: calculatedTotalPages }, (_, index) => index + 1);
  } else {
    const startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(calculatedTotalPages, startPage + maxVisiblePages - 1);
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);
    pages = Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  }

  return {
    data: data.slice((page - 1) * limit, page * limit),
    from: 1 + (page - 1) * limit,
    limit,
    page,
    pages: pages.length ? pages : [1],
    to: Math.min(page * limit, totalSubsetItems),
    totalItems: totalSubsetItems,
    totalPages,
    totalSubsetItems,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function triggerRandomError(rejectError: any): boolean {
  if (environment.name === 'offline') {
    const random = Math.round(Math.random() * 100);
    if (random <= ERROR_RATE_PERCENTAGE) {
      const error = { code: 'unknown-error', message: 'Unknown error' };
      if (typeof rejectError === 'object') {
        rejectError.error(error);
      } else {
        rejectError(error);
      }
      return true;
    }
  }
  return false;
}
